import { UserHelper } from '@/helpers/user.helper';
import { Injectable } from '@angular/core';
import { Sharing, SharingDataCategory, SharingScope, SharingService, SubscriptionState } from '@eemo/api-client';
import { Observable } from 'rxjs';
import { AuthenticationService } from './authentication.service';

@Injectable({
  providedIn: 'root'
})
export class UserRightsService {
  currentUserId: string;
  currentSubscriptionState: SubscriptionState;
  userSharings: Sharing[] = [];

  constructor(private authenticationService: AuthenticationService, private sharingService: SharingService) {
    this.authenticationService.currentUser.subscribe((user) => {
      if (user) {
        this.currentUserId = user.userId;
        this.loadUserRights().subscribe();
      }
    });
    this.authenticationService.subscriptionState.subscribe((s) => {
      if (s) {
        this.currentSubscriptionState = s;
      }
    });
  }

  loadUserRights(): Observable<boolean> {
    return new Observable<boolean>((obs) => {
      this.sharingService.getUserSharingList(this.currentUserId).subscribe((result) => {
        this.userSharings = result;
        obs.next(true);
      });
    });
  }

  hasViewRightOnProperty(propId: string): boolean {
    return this.userSharings.filter((sharing) => sharing.property.uid === propId).length > 0;
  }

  hasUpdateRightOnProperty(propId: string): boolean {
    if (!UserHelper.isSubscriptionActive(this.currentSubscriptionState)) {
      return false;
    }
    return (
      this.userSharings.filter(
        (sharing) => sharing.property.uid === propId && sharing.scope === SharingScope.DELEGATION
      ).length > 0
    );
  }

  hasViewRightOnCategory(propId: string, category: SharingDataCategory): boolean {
    const shares = this.userSharings.filter((sharing) => sharing.property.uid === propId);
    return (
      (shares &&
        shares.length > 0 &&
        // SHARING & PEOPLE category are not implicit
        (!shares[0].allowedData || shares[0].allowedData.length === 0) &&
        SharingDataCategory.SHARING !== category &&
        SharingDataCategory.PEOPLE !== category) ||
      shares[0].allowedData.includes(category)
    );
  }
}
